var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "social-networks" },
    _vm._l(_vm.items, function(item) {
      return _c(
        "a",
        { key: item.name, attrs: { href: item.url, target: "_blank" } },
        [
          _c("f-sprite-icon", {
            attrs: { "icon-link": _vm.$options.icons["Icon" + item.name].id }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }